var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.6,
    height: 79.707,
    viewBox: "0 0 234.6 79.707",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chrismongemeinde2021-wetbewerbslogo-rgb",
    transform: "translate(15 2.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrismongemeinde2023-wettbewerbslogo-rgb",
    transform: "translate(-15 -2.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14900",
    "data-name": "Pfad 14900",
    d: "M12.4,1.6l2,34.2L179.2,21.4V1.6Z",
    fill: "#eb1426"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1951",
    "data-name": "Gruppe 1951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14901",
    "data-name": "Pfad 14901",
    d: "M36.8,16.8,36.1,15a2.173,2.173,0,0,0-1.9-.7c-2.5.2-2.9,3.6-2.8,5.6.1,1.8.8,4.8,3.1,4.7a4.864,4.864,0,0,0,3.5-2l.6.6a5.014,5.014,0,0,1-4,2.6c-3.8.2-6.1-1.9-6.3-5.9-.2-3.8,2.1-6.5,5.8-6.7.9-.1,2.8,0,3.6.7l-.1,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14902",
    "data-name": "Pfad 14902",
    d: "M44.1,14.5a4.531,4.531,0,0,1,4-2.3c3.2-.2,3.8,1.2,4,4.1l.4,6.8,2,.5v.5l-6.8.4V24l1.8-.8-.4-6c-.1-1.8-.2-3.8-2.2-3.7a3.094,3.094,0,0,0-2.4,2.2,6.456,6.456,0,0,0-.2,2.6l.3,5.1,1.7.5v.5l-6.3.5v-.5l1.7-.7L40.7,7l-1.9-.4V6.1l4.8-.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14903",
    "data-name": "Pfad 14903",
    d: "M55,13v-.5l4.3-.7.4,1.8A3.906,3.906,0,0,1,63,11.4a3.807,3.807,0,0,1,1.9.4l-.8,2.9c-.5-.8-1.1-1.6-2.2-1.5-2,.1-2,2.5-1.9,4.1l.3,5.1,2.4.5v.5l-7,.4v-.5l1.7-.9-.6-9.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14904",
    "data-name": "Pfad 14904",
    d: "M66.1,12.3v-.5l4.8-.7.7,10.8,1.8.6V23l-6.4.4v-.5l1.7-.8-.6-9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14905",
    "data-name": "Pfad 14905",
    d: "M82.6,11l-.2,2.9h-.6l-.4-1.6a5.545,5.545,0,0,0-2.8-.6c-.6,0-2,.4-2,1.5.1,1.5,1.7,1.4,3.4,1.9,1.7.4,3.5,1.2,3.6,3.5.2,2.6-1.8,4.3-4.3,4.4a8.357,8.357,0,0,1-4.3-.9l.3-3.4H76l.3,2.1a4.124,4.124,0,0,0,3,.9c1.2-.1,2.4-.7,2.3-2.1s-2.2-1.8-3.4-2.1c-1.5-.4-3.3-.7-3.4-3.2-.2-2.7,1.9-3.7,4.2-3.8A10.222,10.222,0,0,1,82.6,11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14906",
    "data-name": "Pfad 14906",
    d: "M102.4,13.7c-.1-1.5-.2-3.5-2-3.4A2.964,2.964,0,0,0,98,12.5a10.2,10.2,0,0,0-.2,2.7l.3,4.9,1.7.5v.5l-6.5.4V21l1.8-.8L94.7,14c-.1-1.5-.2-3.5-2-3.4a2.964,2.964,0,0,0-2.4,2.2,10.2,10.2,0,0,0-.2,2.7l.3,4.9,1.7.5v.5l-6.4.4v-.5l1.7-.7-.4-9-1.9-.4v-.5l4.5-.7.4,1.8a4.2,4.2,0,0,1,3.6-2.4c2.1-.1,3.2.7,3.8,2a4.3,4.3,0,0,1,3.9-2.5c3.8-.2,4.1,1.8,4.3,4.8l.4,6,2,.5v.5l-6.9.4v-.5l1.8-.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14907",
    "data-name": "Pfad 14907",
    d: "M121.3,14.1c.2,3.9-2.2,6.5-5.9,6.7a5.932,5.932,0,0,1-6.6-6c-.3-4.1,1.9-6.3,5.8-6.6C118.5,8.1,121,9.9,121.3,14.1Zm-6,5.7c2.6-.2,2.7-3.3,2.6-5.4-.1-2-.6-5.2-3.2-5.1-2.5.2-2.7,3.3-2.6,5.3S112.7,20,115.3,19.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14908",
    "data-name": "Pfad 14908",
    d: "M127.2,9.5a4.619,4.619,0,0,1,4-2.4c3.2-.2,3.8,1.2,4,4.1l.4,6.8,2,.5V19l-6.8.4v-.5l1.8-.8-.4-6c-.1-1.8-.2-3.8-2.2-3.7a3.094,3.094,0,0,0-2.4,2.2,6.456,6.456,0,0,0-.2,2.6l.3,5.1,1.7.5v.5l-6.4.4v-.5l1.7-.7-.6-9.3-1.9-.4V8.3l4.5-.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14909",
    "data-name": "Pfad 14909",
    d: "M70.5,6a1.6,1.6,0,1,1-1.7-1.5A1.579,1.579,0,0,1,70.5,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14910",
    "data-name": "Pfad 14910",
    d: "M17.3,2.5a2.578,2.578,0,0,0,1.3,2.1c.9.6,1,1.1,1,2.2v.7a1.739,1.739,0,0,0-1.2,1.4h-.7a2.143,2.143,0,0,1-2.3-.8A2.827,2.827,0,0,0,13.1,7a2.443,2.443,0,0,0-2,2.6,2.506,2.506,0,0,0,2.5,2.3,2.578,2.578,0,0,0,2.1-1.3c.6-.9,1.1-1,2.2-1h.7A1.739,1.739,0,0,0,20,10.8v.7a2.143,2.143,0,0,1-.8,2.3,2.827,2.827,0,0,0-1.1,2.3,2.355,2.355,0,0,0,4.7-.3,2.578,2.578,0,0,0-1.3-2.1c-.9-.6-1-1.1-1-2.2v-.7a1.739,1.739,0,0,0,1.2-1.4h.7a2.328,2.328,0,0,1,2.3.8A2.827,2.827,0,0,0,27,11.3a2.355,2.355,0,1,0-.3-4.7,2.578,2.578,0,0,0-2.1,1.3c-.6.9-1.1,1-2.2,1h-.7c-.2-.9-.7-1.4-1.4-1.4V6.8a2.328,2.328,0,0,1,.8-2.3,2.827,2.827,0,0,0,1.1-2.3A2.506,2.506,0,0,0,19.6,0,2.365,2.365,0,0,0,17.3,2.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14911",
    "data-name": "Pfad 14911",
    d: "M0,33.1,229.5,13l5.1,39.4L5.5,73Z",
    fill: "#662083"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1952",
    "data-name": "Gruppe 1952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14912",
    "data-name": "Pfad 14912",
    d: "M20.8,36.8q3.75-.3,5.7,1.5c1.3,1.2,2,3.1,2.2,5.6v.3l-5.2.4c-.2-2.8-1.1-4.1-2.5-4a2.111,2.111,0,0,0-1.8,1.8,38.371,38.371,0,0,0,.1,7.6,55.483,55.483,0,0,0,.7,6,5.8,5.8,0,0,0,.9,2.2,1.967,1.967,0,0,0,3.3-.8,10.239,10.239,0,0,0,.2-4.2l-.1-.7-2.3.2-.3-3.9,7.5-.6,1.1,13.3-3.7.3-.3-2.4h-.1c-.6,2-2.2,3.1-4.7,3.3a5.585,5.585,0,0,1-4-.9,7.777,7.777,0,0,1-2.4-3.5,31.226,31.226,0,0,1-1.3-7.5,40.22,40.22,0,0,1,0-8.7A6.886,6.886,0,0,1,16,38.3,9.406,9.406,0,0,1,20.8,36.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14913",
    "data-name": "Pfad 14913",
    d: "M44.3,35.3l.4,4.7-7.9.7.4,5,7.4-.6.4,4.7-7.4.6.5,5.7,8.2-.7.4,4.7L33.1,61.2,31,36.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14914",
    "data-name": "Pfad 14914",
    d: "M55.1,34.4l4.2,16.1h.1l1.4-16.6,7.8-.7,2.1,24.9-5,.4L64,39.2h-.1L62,58.8l-4.2.3L52.5,40h-.1L54,59.4l-4.8.4L47.2,35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14915",
    "data-name": "Pfad 14915",
    d: "M85.3,31.8l.4,4.7-7.9.7.4,5,7.4-.6.4,4.7-7.4.7.5,5.7,8.2-.7.4,4.7L74.1,57.8,72,33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14916",
    "data-name": "Pfad 14916",
    d: "M93.5,31.2,95.6,56l-5.4.5L88.1,31.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14917",
    "data-name": "Pfad 14917",
    d: "M103.1,30.4l5.8,15.8h.1L107.6,30l5-.4,2.1,24.9-6.1.5-6.1-16.7h-.1l1.4,17.1-4.8.3L97,30.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14918",
    "data-name": "Pfad 14918",
    d: "M124,28.6c2.6-.2,4.6.5,6,2.2,1.3,1.7,2.2,4.6,2.5,8.9a30.837,30.837,0,0,1-.1,8.3,6.8,6.8,0,0,1-2.2,4,8.729,8.729,0,0,1-4.7,1.6l-7.5.6-2-24.9Zm-.9,20.8,1-.1c.7-.1,1.2-.2,1.7-.3a1.973,1.973,0,0,0,1.1-1.1,8.088,8.088,0,0,0,.5-2.7,29.936,29.936,0,0,0-.2-4.9,24.95,24.95,0,0,0-.7-4.8,4.2,4.2,0,0,0-1.1-2,3.088,3.088,0,0,0-2.3-.4l-1.4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14919",
    "data-name": "Pfad 14919",
    d: "M147.6,26.6l.4,4.7-7.9.7.4,5,7.4-.6.4,4.7-7.4.6.5,5.7,8.2-.7.4,4.7-13.6,1.1-2.1-24.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14920",
    "data-name": "Pfad 14920",
    d: "M165.6,25.3a7.543,7.543,0,0,1,5.4,1.2c1.3,1,2,2.7,2.2,5.1a10.039,10.039,0,0,1-.5,4.7,29.718,29.718,0,0,1-4.1,5.6,12.011,12.011,0,0,0-2.3,3.5l8-.7.4,4.5-14.5,1.2c-.4-4.2,1.1-8.1,4.3-11.6a19.694,19.694,0,0,0,2.8-3.8,5.312,5.312,0,0,0,.6-2.7v-.5a5.918,5.918,0,0,0-.6-2.4,1.361,1.361,0,0,0-1.5-.6,1.736,1.736,0,0,0-1.5,1.1,6.562,6.562,0,0,0-.2,3.3v.3l-5,.4-.1-.8C158.5,28.4,160.7,25.7,165.6,25.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14921",
    "data-name": "Pfad 14921",
    d: "M182.1,24a8.155,8.155,0,0,1,4.6.7,6.343,6.343,0,0,1,2.6,3.3,35.593,35.593,0,0,1,1.4,7.9,26.5,26.5,0,0,1-.1,7.7,7.3,7.3,0,0,1-2,3.9,6.237,6.237,0,0,1-4.3,1.6,8.155,8.155,0,0,1-4.6-.7,6.773,6.773,0,0,1-2.6-3.3,35.593,35.593,0,0,1-1.4-7.9,26.64,26.64,0,0,1,.1-7.7,6.955,6.955,0,0,1,2-3.9A6.743,6.743,0,0,1,182.1,24Zm3,11.6q-.3-3.45-.6-5.1a5.331,5.331,0,0,0-.8-2.2,1.392,1.392,0,0,0-1.4-.5q-1.2.15-1.5,1.8a37.2,37.2,0,0,0,.1,6.6l.1,1.2a31.549,31.549,0,0,0,1,6.7q.6,1.5,1.8,1.5c.8-.1,1.3-.6,1.5-1.7a38.6,38.6,0,0,0-.2-7.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14922",
    "data-name": "Pfad 14922",
    d: "M198.9,22.5a7.543,7.543,0,0,1,5.4,1.2c1.3,1,2,2.7,2.2,5.1a10.04,10.04,0,0,1-.5,4.7,29.718,29.718,0,0,1-4.1,5.6,12.011,12.011,0,0,0-2.3,3.5l8-.7.4,4.5-14.5,1.2c-.4-4.2,1.1-8.1,4.3-11.6a19.694,19.694,0,0,0,2.8-3.8,5.312,5.312,0,0,0,.6-2.7V29a5.918,5.918,0,0,0-.6-2.4,1.361,1.361,0,0,0-1.5-.6,1.736,1.736,0,0,0-1.5,1.1,6.562,6.562,0,0,0-.2,3.3v.3l-5,.4-.1-.8C191.8,25.6,194.1,23,198.9,22.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14923",
    "data-name": "Pfad 14923",
    d: "M215.6,21.1c2.3-.2,4.1.2,5.2,1.2a7.478,7.478,0,0,1,2,5,5.95,5.95,0,0,1-.6,3.4,4.522,4.522,0,0,1-2.2,1.9v.1a4.443,4.443,0,0,1,3,1.6,7.517,7.517,0,0,1,1.3,4,7.881,7.881,0,0,1-1.4,5.7,6.9,6.9,0,0,1-5.1,2.4c-2.7.2-4.6-.2-5.9-1.4s-2-3-2.2-5.7l5.2-.4a6.5,6.5,0,0,0,.8,3.1,1.545,1.545,0,0,0,1.6.8,1.688,1.688,0,0,0,1.5-1A5.754,5.754,0,0,0,219,39a5.711,5.711,0,0,0-.8-3,2.679,2.679,0,0,0-2.4-.7l-1.2.1-.3-3.7,1.4-.1a1.945,1.945,0,0,0,1.8-1.1,5.862,5.862,0,0,0,.3-2.8,4.38,4.38,0,0,0-.6-2.1,1.392,1.392,0,0,0-1.4-.5c-1.4.1-2,1.4-1.8,3.7l-4.8.4v-.1C208.5,24.2,210.7,21.6,215.6,21.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2408",
    "data-name": "Rechteck 2408",
    width: 189.4,
    height: 22.9,
    transform: "translate(31.2 56.8)",
    fill: "#c19947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14924",
    "data-name": "Pfad 14924",
    d: "M37.2,62.5h1.9l1.5,9.2h.1l1.5-9.2h2l1.6,9.2h0l1.5-9.2h1.9L46.9,74.3H44.7l-1.5-8.9h-.1l-1.5,8.9H39.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14925",
    "data-name": "Pfad 14925",
    d: "M50.4,68.4c0-4.2,1.2-6.1,3.9-6.1s3.9,1.9,3.9,6.1-1.2,6.1-3.9,6.1-3.9-1.9-3.9-6.1m5.9-.1c0-4-.9-4.7-2-4.7s-2,.7-2,4.7c0,4.1.9,4.8,2,4.8s2-.7,2-4.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14926",
    "data-name": "Pfad 14926",
    d: "M60.3,62.5h4.2a2.688,2.688,0,0,1,3,3c0,1.5-.7,2.7-2,2.9h0c1.2.1,1.8.8,1.9,2.4a18.483,18.483,0,0,0,.1,2.4.956.956,0,0,0,.6,1H66a1.493,1.493,0,0,1-.3-1,15.483,15.483,0,0,1-.1-2.2c0-1.3-.4-1.8-1.7-1.8H62.4v5.1H60.5V62.5Zm3.4,5.2a1.736,1.736,0,0,0,1.9-1.9c0-1.3-.5-1.9-1.8-1.9H62.2v3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14927",
    "data-name": "Pfad 14927",
    d: "M71.8,62.5h2.4l3.1,11.8h-2l-.7-2.9H71.1l-.8,2.9h-2Zm2.5,7.4-1.4-5.8h0l-1.4,5.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14928",
    "data-name": "Pfad 14928",
    d: "M80.3,62.5V71c0,1.5.6,2.1,1.7,2.1s1.7-.7,1.7-2.1V62.5h1.9v8.3c0,2.7-1.4,3.7-3.6,3.7-2.3,0-3.6-1-3.6-3.7V62.5h1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14929",
    "data-name": "Pfad 14929",
    d: "M87.8,62.5h6.3v1.6H89.7v3.2h4.1v1.6H89.7v5.4H87.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14930",
    "data-name": "Pfad 14930",
    d: "M99.4,62.5h1.9l1.6,9.2h0l1.6-9.2h1.9l1.6,9.2h.1l1.5-9.2h1.9l-2.4,11.8h-2.2l-1.5-8.9h0l-1.5,8.9h-2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2409",
    "data-name": "Rechteck 2409",
    width: 1.9,
    height: 11.8,
    transform: "translate(112.9 62.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14931",
    "data-name": "Pfad 14931",
    d: "M117,62.5h4.2a2.688,2.688,0,0,1,3,3c0,1.5-.7,2.7-2,2.9h0c1.2.1,1.8.8,1.8,2.4a18.483,18.483,0,0,0,.1,2.4.956.956,0,0,0,.6,1h-2.1a1.493,1.493,0,0,1-.3-1c-.1-.7,0-1.4-.1-2.2,0-1.3-.4-1.8-1.7-1.8H119v5.1h-2Zm3.4,5.2a1.736,1.736,0,0,0,1.9-1.9c0-1.3-.5-1.9-1.8-1.9h-1.6v3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14932",
    "data-name": "Pfad 14932",
    d: "M132.5,70.6v.3c0,1.4.6,2.2,1.9,2.2a1.654,1.654,0,0,0,1.8-1.7,1.979,1.979,0,0,0-1.7-2.1l-1.3-.4c-1.7-.7-2.5-1.6-2.5-3.2,0-2.1,1.5-3.3,3.7-3.3,3,0,3.3,1.9,3.3,3.1v.3h-1.9v-.2a1.651,1.651,0,1,0-3.3,0c0,1,.5,1.5,1.8,2l1.3.5c1.7.6,2.4,1.5,2.4,3.1,0,2.5-1.5,3.6-3.9,3.6-2.9,0-3.6-1.9-3.6-3.6v-.3h2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14933",
    "data-name": "Pfad 14933",
    d: "M141.9,64.1h-2.8V62.5h7.5v1.6h-2.8V74.3h-1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14934",
    "data-name": "Pfad 14934",
    d: "M147.3,68.4c0-4.2,1.2-6.1,3.9-6.1s3.9,1.9,3.9,6.1-1.2,6.1-3.9,6.1-3.9-1.9-3.9-6.1m5.9-.1c0-4-.9-4.7-2-4.7s-2,.7-2,4.7c0,4.1.9,4.8,2,4.8s2-.7,2-4.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14935",
    "data-name": "Pfad 14935",
    d: "M156.9,62.5h1.9V72.7h4.6v1.6h-6.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14936",
    "data-name": "Pfad 14936",
    d: "M164.2,72.8l4.9-8.7h-4.6V62.5h6.7v1.6l-4.9,8.6h5v1.6h-7.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14937",
    "data-name": "Pfad 14937",
    d: "M179.1,70.6v.3c0,1.4.6,2.2,1.9,2.2a1.654,1.654,0,0,0,1.8-1.7,1.979,1.979,0,0,0-1.7-2.1l-1.3-.4c-1.7-.7-2.5-1.6-2.5-3.2,0-2.1,1.5-3.3,3.7-3.3,3,0,3.3,1.9,3.3,3.1v.3h-1.9v-.2a1.651,1.651,0,1,0-3.3,0c0,1,.5,1.5,1.8,2l1.3.5c1.7.6,2.4,1.5,2.4,3.1,0,2.5-1.5,3.6-3.9,3.6-2.9,0-3.6-1.9-3.6-3.6v-.3h2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2410",
    "data-name": "Rechteck 2410",
    width: 1.9,
    height: 11.8,
    transform: "translate(186.5 62.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14938",
    "data-name": "Pfad 14938",
    d: "M190.7,62.5H193l3.4,8.8h.1V62.5h1.7V74.3h-2.3l-3.4-9h0v9h-1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14939",
    "data-name": "Pfad 14939",
    d: "M200.6,62.5H204c3.7,0,4.2,2.4,4.2,5.9s-.5,5.9-4.2,5.9h-3.4Zm1.9,10.4h1.6c1.6,0,2.2-1,2.2-4.5,0-3.3-.6-4.5-2.2-4.5h-1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14940",
    "data-name": "Pfad 14940",
    d: "M211.2,66.2V62.5h1.9v3.7l-.3,4.9h-1.3Zm0,6.2h1.9v1.9h-1.9Z",
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.78c37f96f827b960dcff1b7890fed881.svg";